import {RepositoryFactory} from "../../scripts/RepositoryFactory";

const ColumnsRepository = RepositoryFactory.get('columns');
const TemplateRepository = RepositoryFactory.get('templates');

const state = {
    columns: [], //all original columns
    templates: [], //all column templates
    filterColumns: [], // columns with filter_values
    selectedColumns: [], // currently selected columns
};

// getters
const getters = {
    columns(state, getters) {
        let template = (Array.isArray(getters.template) && getters.template.length === 1) ? getters.template[0] : false;
        state.columns.forEach(function (item) {
            let index = getIndex(item.templates, 'name', template['name']);
            item.pivot = item.pivot || {};
            if (index !== false) {
                item.pivot.order = item.templates[index].pivot.order;
            } else {
                item.pivot.order = 1000000000;
            }

        });
        return state.columns.filter(x => x.value === true).sort(sort)
    },
    template(state) {
        return state.templates.filter(x => x.value === true)
    }

};

// actions
const actions = {
    async fetch({commit}) {
        const {data} = await ColumnsRepository.get();
        //data.sort(sortByName);
        commit('setData', {data: data});
    },
    async fetchTemplates({commit}) {
        const {data} = await TemplateRepository.get();
        commit('setTemplates', {data: data});
    }
};

// mutations
const mutations = {
    setData(state, {data}) {
        let defaultColumns = state.templates.find((x => x.name.toLowerCase() === "default"));
        if (typeof defaultColumns !== "undefined" && typeof defaultColumns.columns !== "undefined") {
            defaultColumns = defaultColumns.columns;
        }
        let data_copy = JSON.parse(JSON.stringify(data)); //for filter column
        data.forEach((col) => {
            if (typeof defaultColumns !== 'undefined') {
                col.value = typeof defaultColumns.find((x => x.id === col.id)) !== "undefined";
            }
        });
        state.columns = data;

        data_copy.forEach((col) => {
            col.filter_value = null;
        });
        state.filterColumns = data_copy;
    },
    setTemplates(state, {data}) {
        data.forEach((template) => {
            template.value = template.name.toLowerCase() === "default";
        });
        state.templates = data;
    },
    updateTemplate(state, template) {
        state.templates.forEach((temp) => {
            temp.value = temp.id === template.id;
        });
    },
    updateColumns(state, columns) {
        state.columns = columns;
        /* state.columns.forEach((col) => {
             col.value = typeof template.columns.find((x => x.id === col.id)) !== "undefined";
         });*/
    }
};

function sort(a, b) {
    if (a.pivot.order < b.pivot.order) {
        return -1;
    }
    if (a.pivot.order > b.pivot.order) {
        return 1;
    }
    return 0;
}

/*function sortByName(a, b) {
    if (a.name < b.name) {
        return -1;
    }
    if (a.name > b.name) {
        return 1;
    }
    return 0;
}
*/
function getIndex(arr, key, value) {
    if (arr) {
        for (let i = 0; i < arr.length; i++) {
            if (arr[i][key] === value) {
                return i;
            }
        }
    }
    return false;
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}